module.exports = __webpack_public_path__ + "img/22-3.b8f2b5c9.png";